import { Container, Grid } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Page from 'src/components/Page';
//ユーザのロールを確認し、ページを表示するかどうか決める
export const enqueteCreateHistoryRoute = {
  path: 'enquete-create',
  children: [
    {
      path: '',
      element: (
        <Page title="アンケート履歴">
          <Container maxWidth="xl">
            <Grid container spacing={3}>
              <Grid item xs={12} md={5}>
                <HeaderBreadcrumbs
                  heading="アンケート履歴"
                  links={[
                    // { name: '一般', href: '/general' },
                    { name: 'アンケート履歴', href: '/history/enquete-create' },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </Page>
      ),
    },
  ],
};
